/**
 * Created by zhaoxu on 2018/6/25.
 */
/**
 * Created by zhaoxu on 2018/4/19.
 */
import {
  Button, ButtonGroup, Checkbox, CheckboxButton, CheckboxGroup, Select, Radio, RadioGroup, Message, Notification,
  Table, TableColumn, Tabs, Breadcrumb, BreadcrumbItem, Tooltip, Popover, Form, FormItem, Input,
  Switch, Option, RadioButton, Pagination, MessageBox, Tree, TabPane, Steps
} from 'element-ui'

const vueArr = [
  Button, ButtonGroup, Checkbox, CheckboxButton, CheckboxGroup, Select, Radio, RadioGroup,
  Table, TableColumn, Tabs, Breadcrumb, BreadcrumbItem, Tooltip, Popover, Form, FormItem, Input,
  Switch, Option, RadioButton, Pagination, Tree, TabPane, Steps
];

export default function install(Vue) {
  for (let vm of vueArr) {
    if (vm.name == 'ElPopover' || vm.name == 'ElTooltip') {
      handlePopover(vm);
    }
    Vue.use(vm);
  }
  Vue.prototype.$message = Message;
  Vue.prototype.$notify = Notification;
  Vue.prototype.$msgbox = (obj) => {
    return MessageBox({
      ...obj,
      confirmButtonClass: 'global-msgbox-confirm',
      cancelButtonClass: 'global-msgbox-cancel'
    });
  };

  Vue.prototype.$element = {
    checkForm: function (vm) {
      vm.validate((valid, e) => {
        if (!valid) throw getField(e);
      });
    }
  };
}

function getField(obj) {
  for (let n in obj) {
    let errorArr = obj[n];
    return errorArr[0];
  }
}

function handlePopover(vm) {
  vm.methods.handleMouseLeave = function () {
    this.showPopper = false;
  };
  vm.methods.handleMouseEnter = function () {
    this.showPopper = true;
  };
}
